<div class="athlete-smiley">
    <mat-spinner *ngIf="isLoading; else boxContent" diameter="24" color="accent"></mat-spinner>
    <ng-template #boxContent>
        <i [class]="defaultClass">{{ evaluateIcon() }}</i>
    </ng-template>
</div>
